module.exports = __webpack_public_path__ + "assets/images/amira_system_status_alert_modal_open.634df385fead9c37933f0c8c33391e25.svg";